import { ClientApi } from "@/api/ClientApi";
import { SuscriptionTypeApi } from "@/api/SuscriptionTypeApi";
import { PHONE_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { EINVOICE_INVOICE_TYPE_CODE, TENANT_STATUSES } from "@utils/Constants";

const CREATE_TENANT_CHECKBOX_ROW = [
    {
        "type": "checkbox",
        "name": "createTenant",
        "label": "Crear datos de Tenant",
        "sizing": {
            "sm": {
                "offset": 2
            }
        }
    },
];

/**
 * En edicion pura (no alta, no copia) el checkbox no aplica: los datos del tenant ya
 * existen y no tiene sentido volver a crearlos, asi que se oculta del formulario.
 */
export const getTenantFormConfig = (showCreateTenantCheckbox: boolean) => {
    if (showCreateTenantCheckbox) {
        return TenantFormConfig;
    }
    return {
        ...TenantFormConfig,
        sections: TenantFormConfig.sections.map((section) => {
            if (section.title !== "Datos de Cliente") {
                return section;
            }
            return {
                ...section,
                fields: section.fields.filter((row) => row !== CREATE_TENANT_CHECKBOX_ROW),
            };
        }),
    };
};

const TenantFormConfig = {
    sections: [
        {
            title: "Datos de Suscripcion",
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipoPago",
                        "label": "Tipo Pago",
                        "options": {
                            "manual": "Manual",
                            "onvo": "ONVO",
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "suscriptionTypeId",
                        "label": "Tipo suscripcion",
                        "optionsFunction": () => SuscriptionTypeApi.optionsList(),
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "string",
                        "name": "suscriptionId",
                        "label": "Suscription Id",
                        "sizing": {
                            "sm": 3
                        }
                    }
                ]
            ]
        },
        {
            title: "Datos de Cliente",
            "fields": [
                CREATE_TENANT_CHECKBOX_ROW,
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "clientId",
                        "label": "Cliente",
                        "optionsFunction": async () => {
                            const clients = await ClientApi.optionsList();
                            return {
                                ...clients
                            }
                        },
                        "sizing": {
                            "sm": 7
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "numero",
                        "label": "Numero ",
                        "sizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "text",
                        "name": "nombre",
                        "label": "Nombre Suscripcion",
                        "sizing": {
                            "sm": 7
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "string",
                        "name": "tenant",
                        "label": "Tenant Id",
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": PHONE_INPUT_TYPE,
                        "name": "telefono1",
                        "label": "Telefono 1",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                    },
                    {
                        "type": "text",
                        "name": "email",
                        "label": "Email",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 5
                        },
                        "validation": Yup.string().required("El campo de email es obligatorio")
                            .test("is-valid-emails", "Uno o más correos no son válidos", (value) => {
                                if (!value) return false;

                                // Separar por coma y limpiar espacios
                                const emails = value.split(",").map((email) => email.trim());

                                // Validar cada correo usando una expresión regular o Yup
                                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                return emails.every((email) => emailRegex.test(email));
                            }),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "fecha_pago",
                        "label": "Fecha Pago ",
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "datetime-local",
                        "name": "accessUntil",
                        "label": "Acceso Hasta",
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "status",
                        "label": "Estado",
                        "options": TENANT_STATUSES,
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [

                    {
                        "type": "string",
                        "name": "onvoSubscriptionId",
                        "label": "Suscripcion Id Onvo",
                        "sizing": {
                            "sm": 3
                        }
                    },
                    {
                        "type": "string",
                        "name": "onvoPriceId",
                        "label": "Price Id Onvo",
                        "sizing": {
                            "sm": 3
                        }
                    }
                ],
                [
                    {
                        "type": "string",
                        "name": "codigoActividad",
                        "label": "Codigo Actividad",
                        "sizing": {
                            "sm": 3
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                    {
                        "type": "string",
                        "name": "nombreActividad",
                        "label": "Nombre Actividad",
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ]
            ]
        }
    ],
};


export default TenantFormConfig;